/**
 |--------------------------------------------------------------------------
 | WORKERS : Vue-Router Routes
 |--------------------------------------------------------------------------
 */
const workers = [
  {
    path: '/workers/verified', component: require('pages/workers/all/all.vue').default,
    name: 'verified_workers',
    meta: {requiresAuth: true, title: "Verified Workers", icon: "fas fa-check-circle"}
  }, 
  {
    path: '/workers/unverified', component: require('pages/workers/all/all.vue').default,
    name: 'unverified_workers',
    meta: {requiresAuth: true, title: "Unverified Workers", icon: "fas fa-times-circle"}
  },
  {
    path: '/workers/assigned', component: require('pages/workers/all/all.vue').default,
    name: 'assigned_workers',
    meta: {requiresAuth: true, title: "Assigned Workers", icon: "fas fa-handshake"}
  }, 
  {
    path: '/workers/unassigned', component: require('pages/workers/all/all.vue').default,
    name: 'unassigned_workers',
    meta: {requiresAuth: true, title: "Unassigned Workers", icon: "fas fa-stop"}
  },  
  {
    path: '/workers/all', component: require('pages/workers/all/all.vue').default,
    name: 'all_workers',
    meta: {requiresAuth: true, title: "All Workers", icon: "fas fa-users"}
  }, 
  {
    path: '/workers/all/tax', component: require('pages/workers/all/all_tax.vue').default,
    name: 'all_tax_workers',
    meta: {requiresAuth: true, title: "All Tax Workers", icon: "fas fa-receipt"}
  },
  
  // COMPLIANCE
  {
    path: '/workers/compliance/check', component: require('pages/workers/all/compliance/check').default,
    name: 'worker_compliance_check',
    meta: {requiresAuth: true, title: "Worker Compliance", icon: "fas fa-people-arrows"}
  },
  {
    path: '/workers/compliance/no_nationality', component: require('pages/workers/all/compliance/all_no_nationality').default,
    name: 'all_no_nationality',
    meta: {requiresAuth: true, title: "Workers Compliance - No Nationality", icon: "fas fa-ban"}
  },
  {
    path: '/workers/compliance/uk_ireland', component: require('pages/workers/all/compliance/all_uk_ireland').default,
    name: 'all_uk_ireland',
    meta: {requiresAuth: true, title: "R2W - UK & Ireland", icon: "fas fa-street-view"}
  },
  {
    path: '/workers/compliance/eu', component: require('pages/workers/all/compliance/all_eu').default,
    name: 'all_eu',
    meta: {requiresAuth: true, title: "R2W - EU", icon: "fas fa-globe-europe"}
  },
  {
    path: '/workers/compliance/international', component: require('pages/workers/all/compliance/all_international').default,
    name: 'all_international',
    meta: {requiresAuth: true, title: "R2W - International", icon: "fas fa-atlas"}
  },
  {
    path: '/workers/compliance/recruitment', component: require('pages/workers/all/compliance/recruitment').default,
    name: 'worker_compliance',
    meta: {requiresAuth: true, title: "Worker Compliance", icon: "fas fa-people-arrows"}
  },
  
  // Workers
  {
    path: '/workers/register', component: require('pages/workers/register.vue').default,
    name: 'register_worker',
    meta: {requiresAuth: true, title: "Register Worker", icon: "fas fa-user"}
  }, {
    path: '/workers/profile', component: require('pages/workers/profile.vue').default,
    name: 'worker_profile',
    meta: {requiresAuth: true, title: "Worker Profile", icon: "fas fa-user"}
  }, {
    path: '/workers/edit', component: require('pages/workers/edit.vue').default,
    name: 'edit_worker',
    meta: {requiresAuth: true, title: "Edit Worker", icon: "fas fa-user-edit"}
  },
  // Entity Tests
  {
    path: '/workers/entity_test/new', component: require('pages/workers/entity_test/new.vue').default,
    name: 'entity_test_new',
    meta: {requiresAuth: true, title: "New Entity Test", icon: "fas fa-vial"}
  }, {
    path: '/workers/entity_test/edit', component: require('pages/workers/entity_test/edit.vue').default,
    name: 'entity_test_edit',
    meta: {requiresAuth: true, title: "Edit Entity Test", icon: "fas fa-vials"}
  },
  // Assignments
  {
    path: '/workers/assignment', component: require('pages/workers/assignment.vue').default,
    name: 'worker_assignment',
    meta: {requiresAuth: true, title: "Assign Worker", icon: "fas fa-street-view"}
  },
  // Resourcing
  {
    path: '/workers/search/resourcing', component: require('pages/workers/resourcing/search.vue').default,
    name: 'resourcing_search_workers',
    meta: {requiresAuth: true, title: "Resourcing Search Workers", icon: "fas fa-search"}
  },
  //
  
  // {
  //  path: '/workers/entity_test/view', component: require('pages/workers/entity_test/view.vue').default,
  //  name: 'view_entity_test',
  //  meta: {
  //   requiresAuth: true,
  //   authLevelRequired: userLevelGroups.crm_man_ac_con,
  //   title: "View Entity Test",
  //   icon: "fas fa-eye"
  //  }
  // },
  
  {
    path: '/workers/import', component: require('pages/workers/import.vue').default,
    name: 'import_worker',
    meta: {requiresAuth: true, title: "Import Worker", icon: "fas fa-upload"}
  },
  
  {
   path: '/workers/applicants', component: require('pages/workers/applicants.vue').default,
   name: 'applicants',
   meta: {requiresAuth: true, title: "Website Applications", icon: "fas fa-id-card"}
  },
];
export default workers;
